<template>
  <layout-popup>
    <template slot="header">
      Duplicate schema
    </template>
    <div style="height: 100%; overflow: auto" class="px-4">
      <v-form ref="form">
        <v-text-field
          class="pt-4"
          label="New schema name"
          clearable
          v-model="schemaName"
        />
        <select-chips
          name="tags"
          @drop-item="handleDropChip(tags, $event, 'string')"
          v-model="tags"
          multiple
          label="Tags"
          item-text="name"
          item-value="id"
          chips
          class="ma-0"
        />
        <subheader>Description</subheader>
        <v-textarea
          v-model="description"
          no-resize
          rows="1"
          auto-grow
        ></v-textarea>
      </v-form>
    </div>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="addCopy">Add</v-btn>
    </template>
  </layout-popup>
</template>

<script>
import SelectChips from '@/components/SelectChips';
import LayoutPopup from '@/layouts/LayoutPopup';
import { reactive, toRefs } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import schemas from '@/api/objects/schemas.graphql';

export default {
  components: {
    LayoutPopup,
    SelectChips
  },
  name: 'DuplicateSchema',
  props: {
    entity: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const { mutate: createSchemaCopy } = useMutation(schemas.createSchemaCopy);

    const localState = reactive({
      schemaName: '',
      tags: [],
      description: ''
    });

    const addCopy = () => {
      createSchemaCopy({
        input: {
          newSchemaDescription: localState.description || null,
          newSchemaName: localState.schemaName || null,
          newSchemaTags: localState.tags,
          schemaId: props.entity.id
        }
      }).then(() => {
        emit('close');
      });
    };

    const handleDropChip = (array, id) => {
      array.splice(
        array.findIndex(i => i === id),
        1
      );
    };

    return {
      ...toRefs(localState),
      addCopy,
      handleDropChip
    };
  }
};
</script>
